var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoadingApi)?_c('div',{staticClass:"background-loader"},[_c('div',{staticClass:"loaderItem"})]):_vm._e(),_c('div',{staticClass:"container pl-4 pr-4"},[_c('div',{staticClass:"mb-4"},[_c('Navigation')],1),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }